import React, { useEffect } from "react";
import CertificateCard from "components/widget/CertificateCard";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import { LucideAward } from "lucide-react";





const TrainingCertificationTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete,
	doRecordReset
}) => {


return (
	<HeaderComponent
		title="My Certifications"
		description="View your earned certifications and badges"
		labelIcon={<LucideAward size={20}/>}
	>

		<div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-2 3xl:grid-cols-4" >
				<CertificateCard
				title="React Developer Certification"
				issuedDate="Sep 2025"
				expirationDate="Sep 2027"

				/>
				<CertificateCard
				title="Agile Project Management"
				issuedDate="Aug 2025"
				expirationDate="Never"
				/>
				<CertificateCard
				title="Cybersecurity Fundamentals"
				issuedDate="Jul 2025"
				expirationDate="Jul 2027"
				/>
		</div>
			

	</HeaderComponent>
  );
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingCertificationTable);
